/**
 * @module constants/spacers
 * @desc DHIS2 spacer constants
 */

/** Number values of the spacer definitions */
export const spacersNum = {
    dp4: 4,
    dp8: 8,
    dp12: 12,
    dp16: 16,
    dp24: 24,
    dp32: 32,
    dp48: 48,
    dp64: 64,
    dp96: 96,
    dp128: 128,
    dp192: 192,
    dp256: 256,
    dp384: 384,
    dp512: 512,
    dp640: 640,
}

/** Pixel values of the spacer definitions */
export const spacers = {
    dp4: `${spacersNum.dp4}px`,
    dp8: `${spacersNum.dp8}px`,
    dp12: `${spacersNum.dp12}px`,
    dp16: `${spacersNum.dp16}px`,
    dp24: `${spacersNum.dp24}px`,
    dp32: `${spacersNum.dp32}px`,
    dp48: `${spacersNum.dp48}px`,
    dp64: `${spacersNum.dp64}px`,
    dp96: `${spacersNum.dp96}px`,
    dp128: `${spacersNum.dp128}px`,
    dp192: `${spacersNum.dp192}px`,
    dp256: `${spacersNum.dp256}px`,
    dp384: `${spacersNum.dp384}px`,
    dp512: `${spacersNum.dp512}px`,
    dp640: `${spacersNum.dp640}px`,
}
